import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { ProblemGrid } from './components/ProblemGrid';
import { WhatYoullLearn } from './components/WhatYoullLearn';
import { IntroducingGuide } from './components/IntroducingGuide';
import { WhyTalking } from './components/WhyTalking';
import { Solution } from './components/Solution';
import { PriceAnchor } from './components/PriceAnchor';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-sky-100 selection:text-slate-900" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemGrid data-id="element-4" />
        <WhatYoullLearn data-id="element-5" />
        <IntroducingGuide data-id="element-6" />
        <WhyTalking data-id="element-7" />
        <Solution data-id="element-8" />
        <PriceAnchor data-id="element-9" />
        <SocialProof data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <StickyMobileCTA data-id="element-14" />
    </div>;
}